import axios from 'axios';
import store from '../store';
import addError from './AddError';

export const REQUESTED_LEADS = 'REQUESTED_LEADS';
export const RECEIVED_LEADS = 'RECEIVED_LEADS';
export const REQUEST_LEADS_FAILED = 'REQUEST_LEADS_FAILED';

const getLeads = (params = {}) => (
  (dispatch) => {
    dispatch({
      type: REQUESTED_LEADS,
    });

    let data = [];
    const initialParams = Object.assign({}, params);

    // If no type is specified get leads of both types separately
    // They are requested separately so that some of both are returned
    // - otherwise due to ordering they might all be the same type
    if (!params.type) {
      return axios.get(
        `/api/leads`,
        {
          params: Object.assign(params, { type: 'opportunity' }),
        },
      ).then((response) => {
        data = response.data.data;

        return axios.get(
          `/api/leads`,
          {
            params: Object.assign(params, { type: 'accepted' }),
          },
        );
      }).then((response) => {
        dispatch({
          type: RECEIVED_LEADS,
          leads: response.data.data.concat(data),
          next_page_url: response.data.next_page_url,
          total: response.data.total,
          params: initialParams,
        });
      }).catch((error) => {
        let text = 'An unexpected error has occurred';
        if (typeof error.response === 'object') {
          if (typeof error.response.data === 'string') {
            text = error.response.data;
          } else if (error.response.data.message) {
            text = error.response.data.message;
          }
        }

        dispatch({
          type: REQUEST_LEADS_FAILED,
        });

        return store.dispatch(addError({
          text,
          originalError: error,
        }));
      });
    }

    if (params.type.includes(',')) {
      params.types = params.type.split(',');
      delete params.type;
    }

    return axios.get(`/api/leads`, {
      params,
    }).then((response) => {
      dispatch({
        type: RECEIVED_LEADS,
        leads: response.data.data,
        next_page_url: response.data.next_page_url,
        total: response.data.total,
        to: response.data.to,
        params,
      });
    }).catch((error) => {
      let text = 'An unexpected error has occurred';
      if (typeof error.response === 'object') {
        if (typeof error.response.data === 'string') {
          text = error.response.data;
        } else if (error.response.data.message) {
          text = error.response.data.message;
        }
      }

      dispatch({
        type: REQUEST_LEADS_FAILED,
      });

      return store.dispatch(addError({
        text,
        originalError: error,
      }));
    });

    const fetchLeads = (params) => {
      return axios.get(`/api/leads`, { params })
          .then(response => response.data.data)
          .catch(error => {
            const text = error.response?.data?.message || 'An unexpected error has occurred';
            dispatch({ type: REQUEST_LEADS_FAILED });
            return store.dispatch(addError({ text, originalError: error }));
          });
    };

    if (!params.type) {
      return Promise.all([
        fetchLeads({ ...params, type: 'opportunity' }),
        fetchLeads({ ...params, type: 'accepted' })
      ]).then(([opportunityLeads, acceptedLeads]) => {
        dispatch({
          type: RECEIVED_LEADS,
          leads: [...opportunityLeads, ...acceptedLeads],
          params: initialParams,
        });
      });
    } else {
      return fetchLeads(params).then((leads) => {
        dispatch({
          type: RECEIVED_LEADS,
          leads,
          params,
        });
      });
    }
  }
);


export default getLeads;
